module.exports = "https://r.nearpod.com/assets/media/image/audio-9ed349b17478a7a25dc8064cd95cd2a2.svg";